var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.499268C12.143 0.499268 15.5015 3.85777 15.5015 8.00077C15.5015 12.143 12.143 15.5015 8 15.5015C3.857 15.5015 0.5 12.143 0.5 8.00077C0.49925 3.85777 3.857 0.499268 8 0.499268ZM7.997 6.68677C7.8132 6.68702 7.63589 6.75475 7.49874 6.87711C7.36158 6.99947 7.27414 7.16794 7.253 7.35052L7.24775 7.43752L7.25075 11.564L7.25525 11.6518C7.27639 11.8347 7.36409 12.0034 7.50162 12.1258C7.63915 12.2483 7.81692 12.3158 8.00104 12.3156C8.18517 12.3155 8.3628 12.2475 8.50009 12.1248C8.63737 12.0021 8.72473 11.8332 8.7455 11.6503L8.75 11.5625L8.747 7.43677L8.74175 7.34902C8.72007 7.16659 8.63219 6.99846 8.49477 6.87652C8.35736 6.75459 8.17997 6.68734 7.99625 6.68752L7.997 6.68677ZM8.00075 3.87502C7.75181 3.87502 7.51307 3.97391 7.33704 4.14993C7.16102 4.32596 7.06213 4.5647 7.06213 4.81364C7.06213 5.06258 7.16102 5.30132 7.33704 5.47735C7.51307 5.65338 7.75181 5.75227 8.00075 5.75227C8.24969 5.75217 8.48839 5.65318 8.66435 5.47709C8.8403 5.30099 8.9391 5.06221 8.939 4.81327C8.9389 4.56433 8.83992 4.32563 8.66382 4.14967C8.48772 3.97371 8.24894 3.87492 8 3.87502H8.00075Z",
    fill: "#0580B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.467319a4b2715aa2000936c34bb4a384.svg";
export { ForwardRef as ReactComponent };